<div class="content-wrapper-inner">
  <app-disabled-section-widget></app-disabled-section-widget>
  <div class="page-content">
    <div class="table-topbar mb-20">
      <div class="search-holder">
        <input placeholder="Search by title" type="search" class="form-control table-search" [formControl]="searchControl" />
        <span class="icon-search"></span>
      </div>
    </div>
    <div class="dataTables_wrapper form-inline dt-bootstrap pos-relative">
      <app-test-case-template-table (actions)="templateAction($event)" (changeBatch)="selectedRows = $event"></app-test-case-template-table>

      <div class="table-action-info-bar" *ngIf="selectedRows.length">
        <div class="info-left">
          <div class="text-icon-holder" (click)="batchClear()">
            <span class="icon">
              <span class="selected icon-done"></span>
            </span>
            <span class="text">{{selectedRows.length}} Selected</span>
          </div>
        </div>
        <div class="info-right">
          <div class="text-icon-holder" (click)="onBatchDelete()">
            <span class="icon">
              <span class="far fa-trash-alt"></span>
            </span>
            <span class="text">Delete</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #testCaseTemplateUpdateModalTpl let-dialogRefTemplate="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Update test template</h3>
      <button type="button" class="btn-close" (click)="dialogRefTemplate.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <div>
      <app-test-case-template-update (onTestCaseTemplateSave)="onTestCaseTemplateSave($event)"></app-test-case-template-update>
    </div>
  </div>
</ng-template>
